/* Aimrite Collection — drop-in script */
(function(){
  function init(){
    document.querySelectorAll('[data-aim-readmore]').forEach(function(btn){
      var targetId = btn.getAttribute('data-aim-readmore');
      var target = document.getElementById(targetId);
      if(!target) return;
      btn.addEventListener('click', function(){
        var nowOpen = target.classList.toggle('is-collapsed') === false;
        btn.classList.toggle('is-open', nowOpen);
        btn.setAttribute('aria-expanded', String(nowOpen));
        var lbl = btn.querySelector('.lbl');
        if(lbl){
          lbl.textContent = nowOpen
            ? (btn.dataset.closeLabel || 'Hide full guide')
            : (btn.dataset.openLabel  || 'Read full guide');
        }
      });
    });
  }
  if(document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
